import type { ReactNode } from 'react';
import { Image, View, XStack, YStack } from 'tamagui';

import { BodyMediumEmphasized, BodySmallRegular } from '../text/Typography';

interface GuideBlurbProps {
    guideImageSrc?: string | null;
    heading: string;
    message: string | ReactNode;
}

export const GuideBlurb = ({
    guideImageSrc,
    heading,
    message,
}: GuideBlurbProps) => {
    return (
        <YStack alignItems="center">
            <View
                backgroundColor="$peach300"
                borderRadius={24}
                padding={16}
                width="100%"
            >
                <XStack gap={12} alignItems="flex-start">
                    {guideImageSrc != null && (
                        <Image
                            source={{ uri: guideImageSrc }}
                            width={40}
                            height={40}
                            borderRadius={20}
                            flexShrink={0}
                        />
                    )}

                    <YStack flex={1} gap={8}>
                        <BodyMediumEmphasized color="$black">
                            {heading}
                        </BodyMediumEmphasized>
                        {typeof message === 'string' ? (
                            <BodySmallRegular color="$gray1000">
                                {message}
                            </BodySmallRegular>
                        ) : (
                            message
                        )}
                    </YStack>
                </XStack>
                <View
                    position="absolute"
                    bottom={-6}
                    left={0}
                    right={0}
                    alignItems="center"
                >
                    <View
                        width={0}
                        height={0}
                        backgroundColor="transparent"
                        borderStyle="solid"
                        borderLeftWidth={8}
                        borderRightWidth={8}
                        borderTopWidth={8}
                        borderBottomWidth={0}
                        borderLeftColor="transparent"
                        borderRightColor="transparent"
                        borderTopColor="$peach300"
                        borderBottomColor="transparent"
                    />
                </View>
            </View>
        </YStack>
    );
};
